import { memo, useMemo } from "react";
import { Controller, FieldValues } from "react-hook-form";
import { SelectControllerProps } from "./types";
import { MenuItem, Select } from '@mui/material';
import FieldGroup from './FieldGroup/FieldGroup';

const SelectField = <F extends FieldValues, T>(props: SelectControllerProps<F, T>) => {
	const {
		control,
		name,
		label,
		options,
		tooltipDescription,
		onChangeCallback,
		loading
	} = props

	const renderOptions = useMemo(() => {
		return options.map(({ label, value }) => (
			<MenuItem key={value as string} value={value as string}>{label}</MenuItem>
		))
	}, [options]);
	return (
		<FieldGroup label={label} tooltipDescription={tooltipDescription} loading={loading}>
			<Controller
				name={name}
				control={control}
				rules={{ required: true }}
				render={({ field: { value, onChange } }) => {
					return (
						<Select
							name={name}
							sx={{ backgroundColor: "#fff", fontSize: '14px' }}
							id={name}
							value={value || ""}
							onChange={onChangeCallback ?? onChange}
							variant="outlined"

						>
							{renderOptions}
						</Select>
					);
				}}
			/>
		</FieldGroup>
	);
};

export const SelectInput = memo(SelectField) as typeof SelectField;
